import React from 'react';
import { FaTwitch, FaYoutube, FaTwitter, FaInstagram, FaTiktok } from 'react-icons/fa';
import styles from './Footer.module.css';

const Footer = ({ fixed }) => {
  return (
    <footer className={`${styles.footer} bg-gray-800 text-white p-4 mt-8 dark:bg-gray-900 dark:text-white ${fixed ? styles['footer--fixed'] : ''}`}>
      <div className={`${styles.footerContainer} container mx-auto`}>
        <div className="flex justify-center space-x-6 mb-2">
          <a href="https://www.twitch.tv/Don_Diegons" target="_blank" rel="noopener noreferrer" className="text-white hover:text-purple-400 transition-colors duration-300">
            <FaTwitch size={24} />
          </a>
          <a href="https://www.youtube.com/channel/UCTzYVL_jYgMFrf2iz8V2HFw" target="_blank" rel="noopener noreferrer" className="text-white hover:text-red-500 transition-colors duration-300">
            <FaYoutube size={24} />
          </a>
          <a href="https://twitter.com/Don_Diegons" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition-colors duration-300">
            <FaTwitter size={24} />
          </a>
          <a href="https://www.instagram.com/Don_Diegons/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-pink-500 transition-colors duration-300">
            <FaInstagram size={24} />
          </a>
          <a href="https://www.tiktok.com/@don_diegons" target="_blank" rel="noopener noreferrer" className="text-white hover:text-black dark:hover:text-white transition-colors duration-300">
            <FaTiktok size={24} />
          </a>
        </div>
        <p className={styles.footerText}>&copy; 2025 Diegoncurso. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
